import { createSelector } from 'reselect'
import { getArrayOfObjectValues } from '../../utils';

export const getCrewsSelector = createSelector(
  crew => crew.crews,
  (crewsById) => getArrayOfObjectValues(crewsById)
);